import { render, staticRenderFns } from "./NotesAndOrdersPage.vue?vue&type=template&id=30041408&"
import script from "./NotesAndOrdersPage.vue?vue&type=script&lang=ts&"
export * from "./NotesAndOrdersPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30041408')) {
      api.createRecord('30041408', component.options)
    } else {
      api.reload('30041408', component.options)
    }
    module.hot.accept("./NotesAndOrdersPage.vue?vue&type=template&id=30041408&", function () {
      api.rerender('30041408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/NotesAndOrdersPage.vue"
export default component.exports